import React, { FC, useContext } from 'react';
import { CalendarContext } from '@components/jobs/contextWrap';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './calendar.module.scss';
const cx = classnames.bind(styles);

interface CalenderItems {
  date: string;
  child: JSX.Element[];
}

interface CalendarProps {
  calendarItems?: CalenderItems[];
  isFocusDate: boolean;
}

const Calendar: FC<CalendarProps> = ({ calendarItems, isFocusDate }) => {
  const { calendarInfo, miniCalendarInfo } = useContext(CalendarContext);
  //해당 월의 모든 일수를 가진 array
  const monthDays = DateFormat.getWeeksOfMonth(calendarInfo.calendarDate);

  //해당 월의 일자에 맞는 캘린더 데이터를 mapping
  const calendarEl = monthDays.map((date) => {
    const isSelectDate = DateFormat.format(miniCalendarInfo.selectedDate, 'yyyy-MM-dd') === date;
    const day = new Date(date).getDate();
    const isCurrentMonth = new Date(date).getMonth() === calendarInfo.calendarDate.getMonth();
    const calendarItemEls = calendarItems?.filter((item) => item.date === date).map((item) => item.child);
    return (
      <div className={cx('calendarCell', { highlight: isSelectDate && isFocusDate })} key={date} id={date}>
        {/* [D] 현재 월이 아닌 경우 'disabled' 클래스 추가 */}
        <div className={cx('date', { isSelectDate }, { highlight: isFocusDate }, { disabled: !isCurrentMonth })}>
          {day}
        </div>
        <div className={cx('calendarItemArea')}>{calendarItemEls}</div>
      </div>
    );
  });

  return (
    // 캘린더 영역
    <div className={cx('calendarWrap')}>
      {/* 캘린더 한칸 */}
      {calendarEl}
    </div>
  );
};

export default Calendar;
